import { actions, actionTypes } from 'data'
import { ValidatePasswordActionType } from 'data/actions'
import { PasswordStrengthResponseType } from 'data/Form/Signup/types'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import { call, debounce, put, takeEvery } from 'redux-saga/effects'
import { getPasswordStrength } from 'services/api/auth'
import { Response } from 'utils/fetchApi'

const setPasswordLoading = function* (action: ValidatePasswordActionType) {
  const { form } = action.payload
  yield put(actions.form.change(form, 'fieldLoading', 'newPassword'))
}

const validatePassword = function* (action: void | ValidatePasswordActionType) {
  if (!action) {
    return
  }

  const { form, values } = action.payload

  if (isNil(values.newPassword) || isEmpty(values.newPassword)) {
    yield put(actions.form.change(form, 'passwordStrength', 0))
    yield put(actions.form.change(form, 'fieldLoading', ''))
    action.payload.reject({ newPassword: '' })
    return
  }

  const data: Response<PasswordStrengthResponseType> = yield call(getPasswordStrength, values)

  yield put(actions.form.change(form, 'fieldLoading', ''))

  if (data.ok) {
    yield put(actions.form.change(form, 'passwordStrength', data.response.score))

    if (!data.response.valid) {
      action.payload.reject({
        newPassword: data.response.reason
      })
    }

    return
  }

  if (data.error) {
    action.payload.reject({
      newPassword: 'Error'
    })
    return
  }

  action.payload.resolve()
}

const USER_INPUT_DELAY = 300
export default function* commonForm() {
  yield takeEvery(actionTypes.form.VALIDATE_PASSWORD, setPasswordLoading)
  yield debounce(USER_INPUT_DELAY, actionTypes.form.VALIDATE_PASSWORD, validatePassword)
}
